import axiosInstance from '../axiosInstance';

const unwrapResponse = (response) => response.data?.data ?? response.data;
const noticeEndpoint = (workshopId, noticeId) =>
  `/workshops/${workshopId}/notices/${noticeId}`;

export const createWorkshopNotice = async (workshopId, { title, content, status = 'ACTIVE' }) => {
  try {
    const response = await axiosInstance.post(
      `/workshops/${workshopId}/notices`,
      {
        title,
        content,
        status,
      }
    );
    return unwrapResponse(response);
  } catch (error) {
    console.error('Create Workshop Notice API Error:', error);
    throw error;
  }
};

export const updateWorkshopNotice = async (
  workshopId,
  noticeId,
  { title, content, status, isPinned } = {}
) => {
  try {
    const payload = {
      ...(title !== undefined ? { title } : {}),
      ...(content !== undefined ? { content } : {}),
      ...(status !== undefined ? { status } : {}),
      ...(isPinned !== undefined ? { isPinned } : {}),
    };

    return await executeWithFallback([
      () => axiosInstance.patch(noticeEndpoint(workshopId, noticeId), payload),
      () => axiosInstance.put(noticeEndpoint(workshopId, noticeId), payload),
    ]);
  } catch (error) {
    console.error('Update Workshop Notice API Error:', error);
    throw error;
  }
};

export const deleteWorkshopNotice = async (workshopId, noticeId) => {
  try {
    const response = await axiosInstance.delete(noticeEndpoint(workshopId, noticeId));
    return unwrapResponse(response);
  } catch (error) {
    console.error('Delete Workshop Notice API Error:', error);
    throw error;
  }
};

const executeWithFallback = async (requests = []) => {
  let lastError;
  for (const request of requests) {
    try {
      const response = await request();
      return unwrapResponse(response);
    } catch (error) {
      lastError = error;
    }
  }
  throw lastError;
};

export const toggleWorkshopNoticePin = async (
  workshopId,
  noticeId,
  isPinned
) => {
  try {
    const response = await axiosInstance.put(
      noticeEndpoint(workshopId, noticeId),
      { status: isPinned ? 'PINNED' : 'ACTIVE' }
    );
    return unwrapResponse(response);
  } catch (error) {
    console.error('Toggle Workshop Notice Pin API Error:', error);
    throw error;
  }
};

export const toggleWorkshopNoticeVisibility = async (
  workshopId,
  noticeId,
  isVisible
) => {
  const nextStatus = isVisible ? 'ACTIVE' : 'HIDDEN';

  try {
    const response = await axiosInstance.put(
      noticeEndpoint(workshopId, noticeId),
      { status: nextStatus }
    );
    return unwrapResponse(response);
  } catch (error) {
    console.error('Toggle Workshop Notice Visibility API Error:', error);
    throw error;
  }
};
